function storeCmCellValues(table) {
  table.querySelectorAll('td:not(:first-child)').forEach((cell) => {
    const value = cell.textContent.trim();
    const cmValue = parseFloat(value);

    if (!Number.isFinite(cmValue)) return;

    if (!cell.dataset.cm) {
      cell.dataset.cm = value;
    }
  });
}

function applyTableUnit(table, unit) {
  table.querySelectorAll('td:not(:first-child)').forEach((cell) => {
    if (!cell.dataset.cm) return;

    if (unit === 'inches') {
      const cmValue = parseFloat(cell.dataset.cm);
      cell.textContent = Number.isFinite(cmValue) ? (cmValue / 2.54).toFixed(1) : cell.dataset.cm;
      return;
    }

    cell.textContent = cell.dataset.cm;
  });
}

function bindUnitSwitch(switchRoot, onSelect) {
  const links = switchRoot.querySelectorAll('a[data-unit]');
  if (!links.length) return false;

  const setActive = (activeLink) => {
    links.forEach((link) => {
      link.classList.toggle('active', link === activeLink);
    });
    onSelect(activeLink.dataset.unit);
  };

  links.forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      setActive(link);
    });
  });

  const activeLink = switchRoot.querySelector('a[data-unit].active') || links[0];
  if (activeLink) setActive(activeLink);

  return true;
}

function initGlobalUnitSwitch(root) {
  const globalSwitch = root.querySelector('.size-switch--global');
  if (!globalSwitch) return false;

  const tables = root.querySelectorAll('.size-table--unit-convert table');
  tables.forEach((table) => storeCmCellValues(table));

  return bindUnitSwitch(globalSwitch, (unit) => {
    tables.forEach((table) => applyTableUnit(table, unit));
  });
}

function initPanelUnitSwitch(panel) {
  const table = panel.querySelector('.size-table--unit-convert table');
  const panelSwitch = panel.querySelector('.size-switch:not(.size-switch--global)');

  if (!table || !panelSwitch) return false;

  storeCmCellValues(table);

  return bindUnitSwitch(panelSwitch, (unit) => {
    applyTableUnit(table, unit);
  });
}

function initLegacyDualTables(panel) {
  const cmTable = panel.querySelector('.cm.size-table');
  const inchesTable = panel.querySelector('.inches.size-table');

  if (!cmTable && !inchesTable) return false;

  const panelSwitch = panel.querySelector('.size-switch:not(.size-switch--global)');

  if (!panelSwitch) return false;

  return bindUnitSwitch(panelSwitch, (unit) => {
    const useCm = unit === 'cm';

    if (cmTable) cmTable.style.display = useCm ? '' : 'none';
    if (inchesTable) inchesTable.style.display = useCm ? 'none' : '';
  });
}

function initProductSizeGuide(root) {
  if (!root || root.dataset.sizeGuideInit === 'true') return;

  root.dataset.sizeGuideInit = 'true';

  root.querySelectorAll('.content-tabs .tab-link').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      const href = link.getAttribute('href') || '';
      const targetId = href.startsWith('#') ? href.slice(1) : href.split('#').pop();
      if (!targetId) return;

      const tabs = link.closest('.content-tabs');
      const panel = root.querySelector(`#${CSS.escape(targetId)}`);

      if (!tabs || !panel?.classList.contains('size-tab-content')) return;

      tabs.querySelectorAll('.tab-link').forEach((tabLink) => {
        tabLink.classList.toggle('active', tabLink === link);
      });

      root.querySelectorAll('.size-tab-content').forEach((content) => {
        content.classList.toggle('active', content === panel);
      });
    });
  });

  if (!initGlobalUnitSwitch(root)) {
    root.querySelectorAll('.size-tab-content').forEach((panel) => {
      if (initPanelUnitSwitch(panel)) return;
      initLegacyDualTables(panel);
    });
  }
}

function initProductSizeGuides(container = document) {
  container.querySelectorAll('[data-product-size-guide]').forEach((root) => {
    initProductSizeGuide(root);
  });
}

window.initProductSizeGuides = initProductSizeGuides;

document.addEventListener('DOMContentLoaded', () => {
  initProductSizeGuides();
});
